import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useRef } from "react";
import { useUserContext } from "../../context/DealerProfile";
import SendMailModal from "../../components/SendMailFormat.jsx";
import PaginatedList from '../PaginationList.jsx';
import useSWR, { mutate } from "swr";

import { Mic, MicOff, ArrowLeft } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { AllStates } from "../context/globalState.jsx";
import { AllStates } from "../../context/globalState.jsx";





const OrderDetail = ({ expanded }) => {

  // const [lead, setLead] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const { dealerDetail } = useUserContext();
  const { allState, allStatedispatch } = useContext(AllStates);

  const { id } = useParams();


  const idToFetch = id;
  // const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
  const fetcher = (url) => fetch(url).then((res) => res.json());

  const url = idToFetch ? `/server/dealer_backend/getSpecificLead?id=${idToFetch}` : null;
  const { data, isLoading } = useSWR(url, fetcher, {
    revalidateOnFocus: false,      // don’t fetch when window regains focus
    revalidateOnReconnect: false,  // don’t fetch on network reconnect
    revalidateIfStale: false,      // don’t fetch if cached data is stale
  });

  // console.log({ data })

  useEffect(() => {
    // Revalidate when component mounts (page loads/comes into view)
    if (url) {
      mutate(url);
    }
  }, [url]);
  const lead = data?.status === "success" ? data.data[0] : null;
  const [alternatePhone, setAlternatePhone] = useState(lead?.Alternate_Mobile || "");
  const [callRemarks, setCallRemarks] = useState("");
  const [donorInterest, setDonorInterest] = useState("");
  const [callStatus, setCallStatus] = useState("");
  const [email, setEmail] = useState(lead?.Email || "");
  const [phone, setPhone] = useState(lead?.Mobile || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alternatePhoneError, setAlternatePhoneError] = useState("");
  const [selectedRelatedList, setSelectedRelatedList] = useState(null);
  const [subDisposition, setSubDisposition] = useState("");
  const interestedOptions = [
    "Donated on the spot",
    "Will donate later",
    "Asked for donation link",
    "Need more information/followup"
  ];

  const notInterestedOptions = [
    "Already supporting",
    "Financial constraints",
    "Avoided conversation",
    "No reason given"
  ];
















  const module = 'Leads';

  const [relatedLists, setRelatedLists] = useState([]);

  // useEffect(() => {
  //   const fetchRelatedLists = async () => {

  //     try {
  //       const response = await fetch(`/server/dealer_backend/getRelatedLists?module=${module}`);
  //       const data = await response.json();
  //       // console.log(data);

  //       if (data.status === "success") {
  //         setRelatedLists(data.related_lists);
  //       } else {
  //         // console.error("Failed to fetch transitions:", data.message);
  //       }
  //     } catch (err) {
  //       // console.error("Failed to fetch related lists:", err);
  //     }
  //   };

  //   fetchRelatedLists();
  // }, [module]);


  const fetcher2 = (url) => fetch(url).then(res => res.json());

  const { data: data2 } = useSWR(
    module ? `/server/dealer_backend/getRelatedLists?module=${module}` : null,
    fetcher2,
    {
      revalidateOnFocus: false,      // don’t re-fetch when window/tab regains focus
      revalidateOnReconnect: false,  // don’t re-fetch when network reconnects
      revalidateIfStale: false,      // don’t auto revalidate if cached data is stale
    }
  );




  useEffect(() => {
    if (data2 && data2.status === "success") {
      setRelatedLists(data2.related_lists);
    }
  }, [data2]);










  const [picklistOptions, setPicklistOptions] = useState([]);

  const handleDownload = async (attachmentId) => {
    try {
      const response = await fetch(
        `/server/dealer_backend/downloadAttachments?module=${module}&recordId=${idToFetch}&attachmentId=${attachmentId}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      // Extract filename from Content-Disposition header if available
      const disposition = response.headers.get("Content-Disposition");
      let fileName = `Attachment-${attachmentId}`;
      if (disposition && disposition.includes("filename=")) {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "");
        }
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Force file download
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Optional: cleanup the blob URL
      window.URL.revokeObjectURL(url);

    } catch (error) {
      // console.error("Download error:", error);
    }
  };





  const [picklistFieldId, setPicklistFieldId] = useState(""); // Store selected field ID



  const [notesData, setNotesData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [emails, setEmails] = useState([]);
  const [payments, setPayments] = useState([]);
  const [calls, setCalls] = useState([]);
  const [rescheduleDateTime, setRescheduleDateTime] = useState("");
  const [donationPurpose, setDonationPurpose] = useState("");
  const [callDisposition, setCallDisposition] = useState("");


  const fetchNotes = async () => {
    try {
      const res = await fetch(`/server/dealer_backend/getNotes?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      if (json.status === "success") {
        const sortedNotes = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        setNotesData(sortedNotes);
      } else {
        // console.error("Error fetching notes:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };



  const fetchAttachments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getAttachments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();



      if (json.status === "success") {
        const sortedAttachments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setAttachments(sortedAttachments);

      } else {
        // console.error("Error fetching attachments:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchStatus = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getStatus?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)

      if (json.status === "success") {
        const sortedStatus = json.data.sort((a, b) => new Date(b.Modified_Time) - new Date(a.Modified_Time));
        setStatusData(sortedStatus);

      } else {
        // console.error("Error fetching status:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchEmails = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getEmails?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedEmails = json.data.sort((a, b) => new Date(b.time) - new Date(a.time));
        setEmails(sortedEmails);

      } else {
        // console.error("Error fetching emails:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchPayments = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getPayments?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      // console.log(json)



      if (json.status === "success") {
        const sortedPayments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setPayments(sortedPayments);

      } else {
        // console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };


  const fetchManualCalls = async () => {
    try {

      const res = await fetch(`/server/dealer_backend/getManualCalls?module=${module}&recordId=${idToFetch}`);
      const json = await res.json();

      //  console.log(json)



      if (json.status === "success") {
        const sortedCalls = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

        setCalls(sortedCalls);

      } else {
        // console.error("Error fetching payments:", json.error);
      }
    } catch (err) {
      // console.error("Network error:", err);
    }
  };

  useEffect(() => {
    fetchNotes();
    // fetchStatus();
    fetchAttachments();
    fetchEmails();
    fetchPayments();
    fetchManualCalls()

  }, [idToFetch])

  // useEffect(() => {
  //   if (selectedRelatedList === "Notes") {
  //     fetchNotes();
  //   }
  //   if (selectedRelatedList === "Lead Status History") {
  //     fetchStatus();
  //   }
  // }, [selectedRelatedList]);





  const formatSize = (bytes) => {
    if (!bytes) return "—";
    const kb = bytes / 1024;
    return kb < 1024
      ? `${kb.toFixed(1)} KB`
      : `${(kb / 1024).toFixed(2)} MB`;
  };


  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     setLoading(true);

  //     try {
  //       // Always fetch from server
  //       const response = await fetch(`/server/dealer_backend/getSpecificLead?id=${idToFetch}`);
  //       const data = await response.json();

  //       if (data.status === "success") {
  //         const leadData = data.data[0];
  //         setLead(leadData);
  //       } else {
  //         console.error("Error fetching data:", data.error);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (idToFetch) {
  //     fetchLeadData();
  //   }
  // }, [idToFetch]);









  const formatDateForBackend = (dateInput) => {
    if (!dateInput) return "";

    const date = new Date(dateInput);

    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const offset = -date.getTimezoneOffset(); // Note the sign flip
    const sign = offset >= 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const offsetHours = pad(Math.floor(absOffset / 60));
    const offsetMinutes = pad(absOffset % 60);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
  };


  // Format date for the input field (removes timezone offset)
  const formatDateForInput = (isoString) => {
    if (!isoString) return "";

    let date = new Date(isoString);
    return date.toISOString().slice(0, 16); // Keeps only YYYY-MM-DDTHH:MM
  };





  const [remarksError, setRemarksError] = useState("");



  const handleSubmit = async () => {
    let isValid = true;
    setEmailError("");
    setPhoneError("");
    setAlternatePhoneError("");
    setIsSubmitting(true); // Start loading state

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (email && !emailRegex.test(email)) {
      const msg = "Please enter a valid email address.";
      setEmailError(msg);
      toast.error(msg);
      isValid = false;
    }


    if (phone && !phoneRegex.test(phone)) {
      const msg = "Phone must be a 10-digit number.";
      setPhoneError(msg);
      toast.error(msg);
      isValid = false;
    }

    if (alternatePhone && !phoneRegex.test(alternatePhone)) {
      const msg = "Alternate phone must be a 10-digit number.";
      setAlternatePhoneError(msg);
      toast.error(msg);
      isValid = false;
    }

    if (callStatus === "Reschedule" && isNaN(new Date(rescheduleDateTime))) {
      toast.error("Please select a valid reschedule date and time.");
      isValid = false;
    }

    if (callDisposition === "Call back" && isNaN(new Date(rescheduleDateTime))) {
      toast.error("Please select a valid reschedule date and time.");
      isValid = false;
    }

    if (callDisposition === "Hot lead" && isNaN(new Date(rescheduleDateTime))) {
      toast.error("Please select a valid reschedule date and time.");
      isValid = false;
    }

    if (!callRemarks || callRemarks.trim() === "") {
      const msg = "Remarks are required.";
      setRemarksError(msg);
      isValid = false;
    }


    if (!isValid) {
      setIsSubmitting(false); // Re-enable button
      return;
    }

    // ✅ Find the selected catalyst user from the list


    const callPayload = {
      data: [
        {
          Related_record_of_new_donor: {
            id: lead?.id,
            name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
          },
          Name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
          Email: lead?.Email,
          Mobile_Number: lead?.Mobile,
          Alternate_Mobile: alternatePhone,
          Remarks: callRemarks,
          Donor_Interest: donorInterest,
          Call_Status: callStatus,
          Purpose1: donationPurpose,
          Call_Type: "outbound",
          Sub_Disposition: subDisposition,
          Reschedule_Time:
            (callStatus === "Reschedule" || callDisposition === "Call back" || callDisposition === "Hot lead") && rescheduleDateTime
              ? formatDateForBackend(rescheduleDateTime)
              : null,


          Catalyst_User: lead?.Catalyst_User ? lead?.Catalyst_ID : null,

          // Catalyst_User_Email: selectedCatalystUser?.Email || "",
          Catalyst_User_Email: lead?.Catalyst_User_Email || "",
        },
      ],
    };

    // Additional PUT request to update lead fields
    const leadUpdatePayload = {
      data: [
        {
          Donor_Interest: callStatus,
          Sub_Disposition: subDisposition,
          // Purpose1: donationPurpose,
          Call_Dispositions: callDisposition,
          // or use another variable if you separate remarks from purpose
        },
      ],
    };

    try {
      const leadUpdateRes = await fetch(`/server/dealer_backend/edit-leadDetails/${lead?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(leadUpdatePayload),
      });

      const leadUpdateResult = await leadUpdateRes.json();

      if (!leadUpdateRes.ok || leadUpdateResult.status !== "success") {
        // console.error("Lead update failed:", leadUpdateResult);
        toast.error("Failed to update donor fields.");
        return;
      }

      // toast.success("Call Log Created successfully!");
      // return true;
    } catch (error) {
      // console.error("Error updating lead fields:", error);
      toast.error("An unexpected error occurred while updating lead details.");
    }


    try {
      const callRes = await fetch("/server/dealer_backend/handleCalls", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(callPayload),
      });

      const callResult = await callRes.json();

      if (!callRes.ok || callResult.status !== "success") {
        // console.error("Call creation failed:", callResult);
        toast.error("Failed to create call log.");
        return;
      }

      toast.success("Call log created successfully!");
      await fetchManualCalls();
      if (url) {
        mutate(url); // <-- This will refetch the latest data
      }
      return true;
    } catch (error) {
      // console.error("Error submitting form:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setIsSubmitting(false); // ✅ only reset the state here
    }
  };






  const LeadField = ({ label, value, icon }) => (
    <div className="form-group-field2">
      <label>{label}</label>
      <span>
        {icon && <span className="icon">{icon}</span>}
        {value || "—"}
      </span>
    </div>
  );






  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };


  const vari = `${lead?.First_Name || ''} ${lead?.Last_Name || ''}`.trim();


  const handleEditClick = () => {
    navigate(`/edit-lead/${idToFetch}`);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);

  const totalPages = Math.ceil(calls.length / recordsPerPage);

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentCalls = calls.slice(indexOfFirstRecord, indexOfLastRecord);

  const [donationOptions, setDonationOptions] = useState([]);
  const [callDispositionPicklistOptions, setCallDispositionPicklistOptions] = useState([]);
  const [contactPreferencesOptions, setContactPreferencesOptions] = useState([]);
  const [callDispositionOptions, setCallDispositionOptions] = useState([]);
  const [subDispositionOptions, setSubDispositionOptions] = useState([]);


  // const [callRemarks, setCallRemarks] = useState("");

  const fetchPicklistOptions = async (fieldId, setOptions) => {
    try {
      const res = await fetch(
        `/server/dealer_backend/getPickListValues/${fieldId}?module=Leads&type=used`
      );
      const result = await res.json();
      if (result.status === "success") {
        // console.log({ fieldId, result });
        setOptions(result.data || []);
        const key = `picklist-${fieldId}`
        allStatedispatch({
          type: "add",
          payload: { [key]: result?.data },
        })

      } else {
        console.error("Failed to fetch picklist:", result.error);
      }
    } catch (err) {
      console.error("Error fetching picklist:", err);
    }
  };

  useEffect(() => {

    const picklistMap = [
      { key: 'picklist-760958000004617209', action: () => fetchPicklistOptions("760958000004617209", setDonationOptions), onData: setDonationOptions },
      { key: 'picklist-760958000004576088', action: () => fetchPicklistOptions("760958000004576088", setCallDispositionOptions), onData: setCallDispositionOptions },
      { key: 'picklist-760958000019319045', action: () => fetchPicklistOptions("760958000019319045", setCallDispositionPicklistOptions), onData: setCallDispositionPicklistOptions },
    ]



    picklistMap.forEach(ob => {
      if (!allState[ob?.key]) {
        // console.log("fetching : ", ob.key)
        ob.action();
      } else {
        ob.onData(allState[ob?.key]);
      }
    })

  }, []);














  // const [selectedOwner, setSelectedOwner] = useState("");
  // useEffect(() => {
  //   if (lead && lead.Mobile_User_Email && userList.length > 0) {
  //     const matchedUser = userList.find(
  //       (user) => user.Email.toLowerCase() === lead.Mobile_User_Email.toLowerCase()
  //     );
  //     if (matchedUser) {
  //       setSelectedOwner(matchedUser.Name);

  //     }
  //   }
  // }, [lead, userList]);




  // console.log({ lead })

  useEffect(() => {
    if (isWidgetModalOpen && lead) {
      setEmail(lead.Email || "");
      setPhone(lead.Mobile || "");
      setAlternatePhone(lead.Phone_2 || "");
      setCallRemarks("");
      setDonationPurpose(lead.Purpose1 || "");
      setSubDisposition(lead?.Sub_Disposition);
      // setContactPreference(lead.Contact_Preferences || "");
      setCallStatus(lead.Donor_Interest || "");
      setCallDisposition(lead.Call_Dispositions || "");

      // setRescheduleDateTime(...) if needed
    }
  }, [isWidgetModalOpen, lead]);

  return isLoading ? (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
    </div>
  ) : (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={3000} />
      <header style={{
        position: 'fixed',
        top: 0,
        left: expanded ? '5rem' : '16rem',
        right: 0,
        height: '5rem',
        backgroundColor: 'white',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem',
        borderBottom: '1px solid #e5e7eb',
      }} className="header-fixed mobile-header bg-white h-screen overflow-auto border-b px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* <button className="text-gray-600 hover:text-black text-lg">←</button> */}
          <button
            className="text-gray-600 hover:text-black text-lg"
            onClick={() => navigate('/potential-donor')}  // Go back one step in browser history
            aria-label="Go back"
          >
            <ArrowLeft />
          </button>


          <div className="header-icon w-10 h-10 rounded-full bg-[#2070B9] flex items-center justify-center text-white font-semibold text-lg ">
            {vari.charAt(0).toUpperCase()}
          </div>


          <h1 className="text-xl font-semibold hidden sm:block">
            {`${lead?.First_Name || ''} ${lead?.Last_Name || ''}`.trim()}
          </h1>



        </div>




        <div className="mobile-buttons flex flex-wrap gap-3">
          <button
            className="px-4 py-2 bg-[#2070B9] text-white rounded-lg hover:bg-blue-700 transition text-sm sm:text-base"
            onClick={() => setShowModal(true)}
          >
            Send Email
          </button>

          <button
            className="px-4 py-2 text-[#2070B9] bg-white border border-[#2070B9] rounded-lg hover:bg-[#CBE2FF] transition text-sm sm:text-base"
            onClick={() => setIsWidgetModalOpen(true)}
          >
            Log Call
          </button>

          {/* <button
            className="px-4 py-2 text-[#2070B9] bg-white border border-[#2070B9] rounded-lg hover:bg-[#CBE2FF] transition text-sm sm:text-base"
            onClick={handleEditClick}
          >
            Edit
          </button> */}
        </div>






      </header>
      <div className="flex " style={{ display: 'flex', marginTop: '4rem', height: 'calc(100vh - 4rem)' }}>
        {/* Sidebar */}
        <aside style={{
          position: 'fixed',
          top: '4rem',
          left: expanded ? '16rem' : '16rem',
          bottom: 0,
          backgroundColor: 'white',
          padding: '1rem',
          borderRight: '1px solid #e5e7eb',
          overflowY: 'auto',
        }} className="related-list header-fixed w-64 bg-white border-r p-4 min-h-screen">
          <h3 className="text-lg font-semibold mb-4">Related List</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            {relatedLists.map((item, idx) => (
              <li
                key={item.id || idx}
                onClick={() => {
                  setSelectedRelatedList(item.name);
                  if (item.name === "Notes") {
                    window.location.hash = "#notes";
                  } else if (item.name === "Lead Status History") {
                    window.location.hash = "#status";
                  } else if (item.name === "Attachments") {
                    window.location.hash = "#attach";
                  } else if (item.name === "Emails") {
                    window.location.hash = "#email";
                  } else if (item.name === "Manual Call") {
                    window.location.hash = "#call";
                  } else if (item.name === "Payments") {
                    window.location.hash = "#payment";
                  }
                }}
                className={`flex justify-between items-center hover:bg-gray-100 px-2 py-1 rounded cursor-pointer ${selectedRelatedList === item.name ? "bg-gray-100 font-medium" : ""
                  }`}
              >
                <span className="flex items-center gap-1">
                  {item.display_label || item.name}

                  {/* Count badges */}
                  {item.name === "Notes" && notesData.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {notesData.length}
                    </span>
                  )}
                  {item.name === "Attachments" && attachments.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {attachments.length}
                    </span>
                  )}
                  {item.name === "Emails" && emails.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {emails.length}
                    </span>
                  )}
                  {item.name === "Manual Call" && calls.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {calls.length}
                    </span>
                  )}
                  {item.name === "Payments" && payments.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {payments.length}
                    </span>
                  )}
                  {item.name === "Lead Status History" && statusData.length > 0 && (
                    <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                      {statusData.length}
                    </span>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </aside>



        {/* Main Content */}
        <main style={{
          // marginTop: '4rem',
          // marginLeft: '14rem',
          // height: 'calc(100vh - 4rem)',
          // overflowY: 'auto',
          padding: '1rem',
          flexGrow: 1,
        }}>
          <div className="lead-maindiv lead-container p-4 flex-1">

            {/* Modal for Widget */}
            {isWidgetModalOpen && (
              <div className="modal-overlay fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[9999] px-2 sm:px-0">
                <div className="modal-content bg-white rounded-lg p-4 sm:p-8 w-full max-w-md sm:max-w-4xl shadow-lg overflow-y-auto max-h-[90vh]">
                  <h2 className="text-lg sm:text-2xl font-bold mb-4 sm:mb-6">Create Call Logs</h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-sm sm:text-base">
                    <div>
                      <label className="block text-gray-700 mb-1">Donor Name</label>
                      <input
                        type="text"
                        value={`${lead?.First_Name || ""} ${lead?.Last_Name || ""}`}
                        readOnly
                        className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-1">Email</label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
                      />
                      {emailError && <p className="text-red-500 text-xs mt-1">{emailError}</p>}
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-1">Phone</label>
                      <input
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="w-full bg-gray-100 border border-gray-300 rounded-md px-3 py-2"
                      />
                      {phoneError && <p className="text-red-500 text-xs mt-1">{phoneError}</p>}
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-1">Alternate Phone</label>
                      <input
                        type="text"
                        value={alternatePhone}
                        onChange={(e) => setAlternatePhone(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2"
                      />
                      {alternatePhoneError && <p className="text-red-500 text-xs mt-1">{alternatePhoneError}</p>}
                    </div>

                    <div className="md:col-span-1">
                      <label className="block text-gray-700 mb-1">
                        Call Remarks <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        rows="3"
                        value={callRemarks}
                        onChange={(e) => setCallRemarks(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2"
                      />
                      {remarksError && (
                        <p className="text-red-500 text-sm mt-1">{remarksError}</p>
                      )}
                    </div>

                    <div>
                      <label className="block text-gray-700 mb-1">Donor Interest </label>
                      <select
                        value={donationPurpose}
                        onChange={(e) => setDonationPurpose(e.target.value)}
                        className="w-full border border-gray-300 rounded-md px-3 py-2"
                      >
                        <option value="">Select Interest</option>
                        {donationOptions.map((option, idx) => (
                          <option key={idx} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>

                    {lead?.IFR_Lead_Sources === "Face to Face" && (
                      <div>
                        <label className="block text-gray-700 mb-1">Status</label>
                        <select
                          value={callStatus}
                          onChange={(e) => setCallStatus(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        >
                          <option value="">-- Select --</option>
                          <option value="Interested Now">Interested</option>
                          <option value="Interested Later">Not Interested</option>
                          <option value="Reschedule">Reschedule</option>
                        </select>
                      </div>
                    )}

                    {lead?.IFR_Lead_Sources !== "Face to Face" && (
                      <div>
                        <label className="block text-gray-700 mb-1">Call Dispositions</label>
                        <select
                          value={callDisposition}
                          onChange={(e) => setCallDisposition(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        >
                          <option value="">-- Select --</option>
                          {callDispositionPicklistOptions.map((option, idx) => (
                            <option key={idx} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>
                    )}


                    {lead?.IFR_Lead_Sources === "Face to Face" && (
                      ["Interested Now", "Interested Later"].includes(callStatus) && (
                        <div>
                          <label className="block text-gray-700 mb-1">Sub Disposition</label>
                          <select
                            name="Sub_Disposition"
                            value={subDisposition}
                            onChange={(e) => setSubDisposition(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2"
                          >
                            <option value="">-- Select --</option>
                            {(callStatus === "Interested Now"
                              ? interestedOptions
                              : notInterestedOptions
                            ).map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                      )
                    )}


                    {callStatus === "Reschedule" && (
                      <div>
                        <label className="block text-gray-700 mb-1">Reschedule Date & Time  <span className="text-red-500 ml-1">*</span></label>
                        <input
                          type="datetime-local"
                          value={rescheduleDateTime}
                          onChange={(e) => setRescheduleDateTime(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        />
                      </div>
                    )}

                    {callDisposition === "Call back" && (
                      <div>
                        <label className="block text-gray-700 mb-1">
                          Reschedule Date & Time <span className="text-red-500 ml-1">*</span>
                        </label>
                        <input
                          type="datetime-local"
                          value={rescheduleDateTime}
                          onChange={(e) => setRescheduleDateTime(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        />
                      </div>
                    )}

                    {callDisposition === "Hot lead" && (
                      <div>
                        <label className="block text-gray-700 mb-1">
                          Reschedule Date & Time <span className="text-red-500 ml-1">*</span>
                        </label>
                        <input
                          type="datetime-local"
                          value={rescheduleDateTime}
                          onChange={(e) => setRescheduleDateTime(e.target.value)}
                          className="w-full border border-gray-300 rounded-md px-3 py-2"
                        />
                      </div>
                    )}

                  </div>

                  <div className="flex justify-end space-x-4 mt-8">
                    <button className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600" onClick={() => setIsWidgetModalOpen(false)}>Cancel</button>
                    <button
                      className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 disabled:bg-green-300 disabled:cursor-not-allowed"
                      onClick={async () => {
                        const result = await handleSubmit();

                        if (result) {
                          // If disposition is Reschedule, also create the task
                          // if (callStatus === "Reschedule") {
                          //   await handleSubmitTask();
                          // }

                          setIsWidgetModalOpen(false); // Close modal after all actions succeed
                        }
                      }}
                      disabled={isSubmitting}
                    >
                      Submit
                    </button>

                  </div>
                </div>
              </div>
            )}





            {/* Lead Status Card */}
            {/* <div className="card lead-status-card">
            <div className="card-header">
              <h3><span className="lead-headings">Current State</span> <span>{lead?.Lead_Status}</span></h3>
            </div>

            {isModalOpen && selectedTransition && (
              <>
                {selectedTransition.fields.length === 0 ? (
                  (() => {
                    handleSubmit();
                    return null;
                  })()
                ) : (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h2>{selectedTransition.field_value}</h2>
                      <div className="transitions">
                        {selectedTransition.fields.map((field, idx) => (
                          <div key={idx} className="modal-field">
                            {field.display_label !== "message" && <label>{field.display_label}</label>}
                            {renderInputField(field)}
                          </div>
                        ))}
                      </div>
                      <div className="space-x-2">
                        <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700" onClick={handleSubmit}>Submit</button>
                        <button className="mr-2 px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-100" onClick={() => setIsModalOpen(false)}>Close</button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="lead-actions">
              {lead?.Lead_Status !== "Interested" && (
                <>
                  <span className="lead-headings">Transition</span>
                  <div className="lead-actions-button">
                    {transitions.map((transition) => (
                      <button key={transition.id} className="action-btn" onClick={() => handleOpenModal(transition)}>
                        {transition.next_field_value}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div> */}

            {/* Lead Information */}
            <div className="lead-profile-container">
              {lead ? (
                <div className="lead-cards">
                  <div className="lead-card">
                    {/* <div className="form-group-field"><label>Potential Donor Owner</label><span>{lead.Owner || "—"}</span></div> */}
                    {/* <div className="form-group-field"><label>Potential Donor Source</label><span>{lead.Lead_Source || "—"}</span></div> */}
                    <div className="form-group-field"><label>Email ID</label><span className="email-value">{lead?.Email || "—"}</span></div>
                    <div className="form-group-field"><label>Mobile</label><span>{lead.Mobile ? <FaPhoneAlt className="phone-icon" /> : null}{lead.Mobile || "—"}</span></div>
                    <div className="form-group-field">
                      <label>Potential Donor Status</label>
                      <span
                        className={`
    inline-block w-fit
    text-xs font-semibold px-2 py-1 rounded-[12px]
    ${lead?.Lead_Status === "Contacted"
                            ? "bg-green-300 text-white"
                            : lead?.Lead_Status === "Interested"
                              ? "bg-green-500 text-black"
                              : lead?.Lead_Status === "Junk Lead"
                                ? "bg-pink-400 text-white"
                                : lead?.Lead_Status === "Not Interested"
                                  ? "bg-red-400 text-white"
                                  : lead?.Lead_Status === "RNR"
                                    ? "bg-wheat-500 text-white"
                                    : lead?.Lead_Status === "Convert to Donor"
                                      ? "bg-gray-500 text-white"
                                      : "bg-yellow-300 text-black"}
  `}
                      >
                        {lead?.Lead_Status || "—"}
                      </span>

                    </div>

                  </div>
                </div>
              ) : (
                <p className="loading-text">Loading lead details...</p>
              )}
            </div>

            {/* Donor Info Section */}
            <div className="lead-container2">
              <h3 className="lead-title">Donor Information</h3>
              <hr className="lead-divider" />
              {lead && (
                <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">
                  {/* Left Column */}
                  <div className="space-y-3">
                    <LeadField
                      label="IFR Lead Source"
                      value={
                        <span
                          className="inline-block px-2 py-1 text-xs font-medium rounded-full w-fit"
                          style={{
                            backgroundColor: {
                              "Websites": "#f97316",
                              "Face to Face": "#86efac",
                              "Google Ads": "#f9a8d4",
                              "Facebook Ads": "#60a5fa",
                              "Events": "#a78bfa"
                            }[lead?.IFR_Lead_Sources] || "#d1d5db",
                            color:
                              lead?.IFR_Lead_Sources === "Face to Face" ||
                                !["Websites", "Google Ads", "Facebook Ads", "Events"].includes(lead?.IFR_Lead_Sources)
                                ? "#000"
                                : "#fff",
                          }}
                        >
                          {lead?.IFR_Lead_Sources || "—"}
                        </span>
                      }
                    />
                    <LeadField
                      label="Mobile"
                      value={
                        <span className="flex items-center gap-1">
                          <FaPhoneAlt className="text-green-500" />
                          {lead?.Mobile || "—"}
                        </span>
                      }
                    />
                    <LeadField
                      label="Email"
                      value={<span className="email-value">{lead?.Email || "—"}</span>}
                    />
                    <LeadField
                      label="Secondary Email"
                      value={<span className="break-words">{lead?.Secondary_Email || "—"}</span>}
                    />
                    <LeadField
                      label="Phone"
                      value={
                        <span className="flex items-center gap-1">
                          <FaPhoneAlt className="text-green-500" />
                          {lead?.Phone || "—"}
                        </span>
                      }
                    />
                    {/* <LeadField label="PAN Number" value={lead?.PAN_Number || "—"} /> */}
                    <LeadField label="Payment Type" value={lead?.Payment_Type1 || "—"} />
                    <LeadField label="Mode of Payment" value={lead?.Mode_of_Payment || "—"} />
                    <LeadField label="Donation Amount" value={lead?.Donation_Amount || "—"} />
                    {/* ✅ Add these */}
                    <LeadField label="Event Name" value={lead?.Event_Name || "—"} />
                    <LeadField
                      label="Payment URL"
                      value={
                        lead?.Payment_URL ? (
                          <a
                            href={lead.Payment_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 underline break-all"
                          >
                            {lead.Payment_URL}
                          </a>
                        ) : (
                          "—"
                        )
                      }
                    />
                    <LeadField label="Social ID" value={lead?.Social_Id || "—"} />
                    {/* <LeadField label="Layout" value={lead?.Layout || "—"} /> */}

                  </div>

                  {/* Right Column */}
                  <div className="space-y-3">
                    <LeadField
                      label="Potential Donor Name"
                      value={`${lead?.First_Name || ''} ${lead?.Last_Name || ''}`.trim()}
                    />
                    <LeadField
                      label="Potential Donor Status"
                      value={
                        <span className="bg-yellow-300 text-black px-2 py-1 rounded-md text-xs font-semibold w-fit inline-block">
                          {lead?.Lead_Status || "—"}
                        </span>
                      }
                    />
                    {lead?.IFR_Lead_Sources !== "Face to Face" && (
                      <LeadField
                        label="Call Dispositions"
                        value={lead?.Call_Dispositions || "—"}
                      />
                    )}

                    <LeadField label="Date Of Birth" value={lead?.Date_of_Birth || "—"} />
                    {lead?.IFR_Lead_Sources !== "Face to Face" && (
                      <LeadField
                        label="List Name"
                        value={lead?.List_Name || "—"}
                      />
                    )}
                    <LeadField label="Donor type" value={lead?.Donor_type || "—"} />
                    <LeadField label="Purpose Type" value={lead?.Purpose_Type || "—"} />
                    <LeadField label="Donor Potential Type" value={lead?.Potential_Type || "—"} />
                    <LeadField label="Contact Method" value={lead?.Contact_Method || "—"} />
                    <LeadField
                      label="Status"
                      value={
                        <span
                          className="inline-block px-2 py-1 text-xs font-medium rounded-full text-white w-fit"
                        // style={{
                        //   backgroundColor:
                        //     lead?.Donor_Interest === "Interested Now"
                        //       ? "#22c55e"
                        //       : lead?.Donor_Interest === "Interested Later"
                        //         ? "#ef4444"
                        //         : "#d1d5db",
                        // }}
                        >
                          {lead?.Donor_Interest || "—"}
                        </span>
                      }
                    />
                    <LeadField
                      label="Sub Dispositions"
                      value={<span className="inline-block w-fit break-words">{lead?.Sub_Disposition || "—"}</span>}
                    />
                    {/* <LeadField label="Potential Donor Owner" value={lead?.Owner || "—"} /> */}
                    <LeadField
                      label="Modified By"
                      value={
                        <div>
                          <div>{lead?.Catalyst_User || "—"}</div>

                        </div>
                      }
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Address Info Section */}
            <div className="lead-container2">
              <h3 className="lead-title">Address Information</h3>
              <hr className="lead-divider" />
              {lead && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                  <div className="space-y-3">
                    <LeadField label="Street" value={lead?.Street || "—"} />
                    <LeadField label="State" value={lead?.State || "—"} />
                    <LeadField label="Pin Code" value={lead?.Zip_Code || "—"} />
                  </div>
                  <div className="space-y-3">
                    <LeadField label="City" value={lead?.City || "—"} />
                    <LeadField label="Country" value={lead?.Country || "—"} />
                  </div>
                </div>
              )}
            </div>





            {lead?.IFR_Lead_Sources === "Face to Face" && (
              <div className="lead-container2">
                <h3 className="lead-title">Face to Face Information</h3>
                <hr className="lead-divider" />
                {lead && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                    <div className="space-y-3">
                      <LeadField label="Donation Purpose" value={lead?.Purpose1} />
                      <LeadField label="Meeting Location" value={lead?.Meeting_Location} />
                      <LeadField label="Region" value={lead?.Region} />
                    </div>
                    <div className="space-y-3">
                      <LeadField label="ID Proof Type" value={lead?.ID_Proof_Type} />
                      <LeadField label="ID Proof Number" value={lead?.ID_Proof_Number} />
                    </div>
                  </div>
                )}
              </div>
            )}



            <div id="notes" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Notes</h3>

              {notesData.length > 0 && (
                <PaginatedList data={notesData}>
                  {({
                    data,
                    currentPage,
                    totalPages,
                    totalRecords,
                    startEntry,
                    endEntry,
                    recordsPerPage,
                    handleChangePage,
                    handlePageSizeChange,
                  }) => (
                    <>
                      {/* Table */}
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b bg-gray-50 text-left">
                              <th className="py-2 px-3">Note</th>
                              <th className="py-2 px-3">Potential Donor</th>
                              <th className="py-2 px-3">Time</th>
                              {/* <th className="py-2 px-3">Owner</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((note, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="py-2 px-3">{note.Note_Content || "—"}</td>
                                <td className="py-2 px-3">{note.Parent_Id?.name || "—"}</td>
                                <td className="py-2 px-3">now</td>
                                {/* <td className="py-2 px-3">{note.Owner?.name || "—"}</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination controls */}
                      <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                        {/* Entry range info */}
                        <div>
                          Showing {startEntry} to {endEntry} of {totalRecords} Entries
                        </div>

                        {/* Page size selector */}
                        <div className="flex items-center gap-2">
                          <label htmlFor="notesPageSize">Records per list:</label>
                          <select
                            id="notesPageSize"
                            value={recordsPerPage}
                            onChange={handlePageSizeChange}
                            className="border px-2 py-1 rounded"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                          </select>
                        </div>

                        {/* Pagination buttons */}
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleChangePage(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Prev
                          </button>
                          <button
                            onClick={() => handleChangePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </PaginatedList>)}
            </div>




            <div id="status" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Lead Status History</h3>

              {statusData.length > 0 && (
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border-collapse">
                    <thead>
                      <tr className="border-b bg-gray-50 text-left">
                        <th className="py-2 px-3">Potential Donor Status</th>
                        <th className="py-2 px-3">Duration (Days)</th>
                        {/* <th className="py-2 px-3">Modified Time</th> */}
                        {/* <th className="py-2 px-3">Modified By</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {statusData
                        .slice(0, 10) // Only show recent 10 entries
                        .map((item, idx) => (
                          <tr key={idx} className="border-t">
                            <td className="py-2 px-3">
                              <span className="bg-green-300 text-black px-3 py-1 rounded-full text-xs font-medium">
                                {item.Lead_Status || "—"}
                              </span>
                            </td>
                            <td className="py-2 px-3">—</td>

                            {/* <td className="py-2 px-3">{item.Modified_By?.name || "—"}</td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>







            <div id="attach" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Attachments</h3>

              {attachments.length > 0 && (
                <PaginatedList data={attachments}>
                  {({
                    data,
                    currentPage,
                    totalPages,
                    totalRecords,
                    startEntry,
                    endEntry,
                    recordsPerPage,
                    handleChangePage,
                    handlePageSizeChange,
                  }) => (
                    <>
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b bg-gray-50 text-left">
                              <th className="py-2 px-3">File Name</th>
                              {/* <th className="py-2 px-3">Attached By</th> */}
                              <th className="py-2 px-3">Date Added</th>
                              <th className="py-2 px-3">Size</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((att, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="py-2 px-3">
                                  {att.File_Name ? (
                                    <a
                                      href="#"
                                      className="text-blue-600 underline cursor-pointer"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDownload(att.id);
                                      }}
                                    >
                                      {att.File_Name}
                                    </a>
                                  ) : "—"}
                                </td>
                                {/* <td className="py-2 px-3">{att.Owner?.name || "—"}</td> */}
                                <td className="py-2 px-3">{att.Created_Time ? formatDate(att.Created_Time) : "—"}</td>
                                <td className="py-2 px-3">{formatSize(att.Size)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                        <div>Showing {startEntry} to {endEntry} of {totalRecords} Entries</div>

                        <div className="flex items-center gap-2">
                          <label htmlFor="attachPageSize">Records per list:</label>
                          <select
                            id="attachPageSize"
                            value={recordsPerPage}
                            onChange={handlePageSizeChange}
                            className="border px-2 py-1 rounded"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                          </select>
                        </div>

                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleChangePage(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Prev
                          </button>

                          <button
                            onClick={() => handleChangePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </PaginatedList>
              )}
            </div>



            <div id="email" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Emails</h3>

              {emails.length > 0 && (<PaginatedList data={emails}>
                {({
                  data,
                  currentPage,
                  totalPages,
                  totalRecords,
                  startEntry,
                  endEntry,
                  recordsPerPage,
                  handleChangePage,
                  handlePageSizeChange,
                }) => (
                  <>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm border-collapse">
                        <thead>
                          <tr className="border-b bg-gray-50 text-left">
                            <th className="py-2 px-3">Subject</th>
                            <th className="py-2 px-3">Date</th>
                            <th className="py-2 px-3">Source</th>
                            <th className="py-2 px-3">Sent By</th>
                            <th className="py-2 px-3">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((email, idx) => (
                            <tr key={idx} className="border-t">
                              <td className="py-2 px-3">{email.subject || "—"}</td>
                              <td className="py-2 px-3">{email.time ? formatDate(email.time) : "—"}</td>
                              <td className="py-2 px-3">{email.Source || "—"}</td>
                              <td className="py-2 px-3">{email.from?.user_name || "—"}</td>
                              <td className="py-2 px-3">{email.status?.[0]?.type || "—"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                      <div>
                        Showing {startEntry} to {endEntry} of {totalRecords} Entries
                      </div>

                      <div className="flex items-center gap-2">
                        <label htmlFor="emailPageSize">Records per list:</label>
                        <select
                          id="emailPageSize"
                          value={recordsPerPage}
                          onChange={handlePageSizeChange}
                          className="border px-2 py-1 rounded"
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                        </select>
                      </div>

                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleChangePage(currentPage - 1)}
                          disabled={currentPage === 1}
                          className="px-3 py-1 border rounded disabled:opacity-50"
                        >
                          Prev
                        </button>

                        <button
                          onClick={() => handleChangePage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          className="px-3 py-1 border rounded disabled:opacity-50"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </PaginatedList>
              )}
            </div>

            <div id="call" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Manual Call</h3>

              {calls.length > 0 && (
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm border-collapse">
                    <thead>
                      <tr className="border-b bg-gray-50 text-left">
                        <th className="py-2 px-3">Donor Name</th>
                        <th className="py-2 px-3">Created Time</th>
                        <th className="py-2 px-3">Remarks</th>
                        <th className="py-2 px-3">Reschedule Time</th>
                        <th className="py-2 px-3">Status</th>
                        <th className="py-2 px-3">Purpose</th>


                      </tr>
                    </thead>
                    <tbody>
                      {calls
                        .slice(0, 10)
                        .map((call, idx) => (
                          <tr key={idx} className="border-t">
                            <td className="py-2 px-3">
                              {call.Name ? (
                                <a
                                  href={`/app/call-details/${call.id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 hover:underline"
                                >
                                  {call.Name}
                                </a>
                              ) : ""}
                            </td>
                            <td className="py-2 px-3">
                              {call.Created_Time ? new Date(call.Created_Time).toLocaleString() : ""}
                            </td>
                            <td className="py-2 px-3">{call.Remarks || ""}</td>
                            <td className="py-2 px-3">
                              {call.Reschedule_Time
                                ? new Date(call.Reschedule_Time).toLocaleString()
                                : "N/A"}
                            </td>
                            <td className="py-2 px-3">{call.Call_Status || ""}</td>
                            <td className="py-2 px-3">{call.Purpose1 || ""}</td>

                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>


            <div id="payment" className="lead-container2">
              <h3 className="text-lg font-semibold mb-3">Payments</h3>

              {payments.length > 0 && (
                <PaginatedList data={payments}>
                  {({
                    data,
                    currentPage,
                    totalPages,
                    totalRecords,
                    startEntry,
                    endEntry,
                    recordsPerPage,
                    handleChangePage,
                    handlePageSizeChange,
                  }) => (
                    <>
                      <div className="overflow-x-auto">
                        <table className="min-w-full text-sm border-collapse">
                          <thead>
                            <tr className="border-b bg-gray-50 text-left">
                              <th className="py-2 px-3">Zoho Payments ID</th>
                              <th className="py-2 px-3">Payment Status</th>
                              <th className="py-2 px-3">Billing Phone</th>
                              <th className="py-2 px-3">Amount</th>
                              <th className="py-2 px-3">Transaction Date</th>
                              <th className="py-2 px-3">Donation Frequency</th>
                              <th className="py-2 px-3">Payment Mode</th>
                              <th className="py-2 px-3">Catalyst User</th>
                              <th className="py-2 px-3">Created Time</th>
                              {/* <th className="py-2 px-3">Email</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((payment, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="py-2 px-3">
                                  {payment.Name ? (
                                    <a
                                      href={`/app/payment-details/${payment.id}`}
                                      className="text-blue-600 hover:underline"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {payment.Name}
                                    </a>
                                  ) : "—"}
                                </td>
                                <td className="py-2 px-3">{payment.Order_Status || ""}</td>
                                <td className="py-2 px-3">{payment.Billing_Phone || ""}</td>
                                <td className="py-2 px-3">
                                  {payment.Amount !== undefined && payment.Amount !== null
                                    ? `₹${payment.Amount.toLocaleString()}`
                                    : "-"}
                                </td>

                                <td className="py-2 px-3">{payment.Transaction_Date || ""}</td>
                                <td className="py-2 px-3">{payment.Payment_Frequency || ""}</td>
                                <td className="py-2 px-3">{payment.Payment_Gateway || ""}</td>
                                <td className="py-2 px-3">{payment.Catalyst_User?.name || ""}</td>
                                <td className="py-2 px-3">
                                  {payment.Created_Time
                                    ? new Date(payment.Created_Time).toLocaleString()
                                    : ""
                                  }
                                </td>

                                {/* <td className="py-2 px-3">{payment.Email || "—"}</td> */}
                              </tr>
                            ))}
                          </tbody>

                        </table>
                      </div>

                      <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                        <div>
                          Showing {startEntry} to {endEntry} of {totalRecords} Entries
                        </div>

                        <div className="flex items-center gap-2">
                          <label htmlFor="paymentPageSize">Records per list:</label>
                          <select
                            id="paymentPageSize"
                            value={recordsPerPage}
                            onChange={handlePageSizeChange}
                            className="border px-2 py-1 rounded"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                          </select>
                        </div>

                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleChangePage(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Prev
                          </button>

                          <button
                            onClick={() => handleChangePage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="px-3 py-1 border rounded disabled:opacity-50"
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </PaginatedList>
              )}
            </div>



            {showModal && (
              <SendMailModal
                idToFetch={lead?.id}
                lead={lead}
                firstName={lead?.First_Name}
                lastName={lead?.Last_Name}
                onEmailSent={fetchEmails} // ✅ pass function here
                onClose={() => setShowModal(false)}
              />
            )}














          </div>
        </main>
      </div>
    </React.Fragment>
  );
};





export default OrderDetail;
